import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import menuItems from "../constants/menuItems";
import Navbar from "../components/Navbar";

const LABELS = {
	name: "Nazwa",
	street: "Ulica",
	postalCode: "Kod pocztowy",
	city: "Miasto",
	phone: "Telefon",
	email: "Email",
	extraInfo: "Dodatkowe informacje"
};

function Kontakt({ onLogout, userRole }) {
	const [documents, setDocuments] = useState([]);
	const [status, setStatus] = useState({ type: "", message: "" });

	const formatDocTitle = (value) => {
		if (!value) {
			return "Kontakt";
		}
		if (value === "main") {
			return "Kontakt";
		}
		const spaced = value.replace(/[_-]+/g, " ").trim();
		return spaced ? spaced.charAt(0).toUpperCase() + spaced.slice(1) : "Kontakt";
	};

	const formatFieldLabel = (key) => {
		if (LABELS[key]) {
			return LABELS[key];
		}
		const spaced = String(key).replace(/[_-]+/g, " ").trim();
		if (!spaced) {
			return "Informacje";
		}
		return spaced.charAt(0).toUpperCase() + spaced.slice(1);
	};

	useEffect(() => {
		const unsubscribe = onSnapshot(
			collection(db, "contactInfo"),
			(snapshot) => {
				const items = snapshot.docs.map((docSnap) => ({
					id: docSnap.id,
					...docSnap.data()
				}));
				setDocuments(items);
			},
			(error) => {
				setStatus({
					type: "error",
					message: error.message || "Nie udalo sie wczytac kontaktu."
				});
			}
		);

		return () => unsubscribe();
	}, []);

	const sectionsByDoc = useMemo(
		() =>
			documents.map((item) => {
				const fields = Object.entries(item)
					.filter(
						([key, value]) =>
							key !== "id" && typeof value === "string" && value.trim() !== ""
					)
					.sort(([left], [right]) => left.localeCompare(right));

				return { id: item.id, fields };
			}),
		[documents]
	);

	const hasContent = sectionsByDoc.some((doc) => doc.fields.length > 0);

	return (
		<main className="ClientShell">
			<div className="ClientNavWrap">
				<Navbar
					menuItems={menuItems}
					onLogout={onLogout}
					userRole={userRole}
				/>
			</div>

			<section className="ClientHero">
				<div className="WelcomePanel">
					<p className="Badge">Kontakt</p>
					<h1 className="Title">Dane kontaktowe</h1>
					<p className="Subtitle">Wszystkie informacje kontaktowe z bazy.</p>

					{status.message ? (
						<p className={status.type === "error" ? "Error" : "Success"}>
							{status.message}
						</p>
					) : null}

					{!hasContent ? (
						<p className="Muted">Brak danych kontaktowych.</p>
					) : null}
				</div>

				{sectionsByDoc.map((doc) => (
					<div className="WelcomePanel" key={doc.id}>
						<p className="Badge">{formatDocTitle(doc.id)}</p>
						{doc.fields.length === 0 ? (
							<p className="Muted">Brak danych w tej sekcji.</p>
						) : (
							doc.fields.map(([key, value]) => (
								<div className="Field" key={`${doc.id}-${key}`}>
									<span className="Label">{formatFieldLabel(key)}</span>
									<p className="Subtitle" style={{ whiteSpace: "pre-wrap" }}>
										{value}
									</p>
								</div>
							))
						)}
					</div>
				))}
			</section>
		</main>
	);
}

export default Kontakt;
